"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// Base error classes to extend from
class ApplicationError extends Error {
    get name() {
        return this.constructor.name;
    }
}
exports.default = ApplicationError;
//# sourceMappingURL=ApplicationError.js.map